import { GridCol, mixins, styled } from '@bob/library'

export const Button = styled.button`
  ${mixins.cta.primary('blue')};
`

export const Title = styled.h1`
  ${mixins.typography.headlineLarge};
`

export const Description = styled.p`
  ${mixins.typography.paragraphMedium};
  text-align: justify;
  ${mixins.margin.bottom(30)};
`

export const Content = styled(GridCol)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`
